const ExperienceHighlight = ({
  title,
  content,
  icon: Icon,
}: {
  title: string
  content?: string
  icon: any
}) => (
  <li className="flex items-start space-x-4 py-2">
    <span className="mt-1">
      <Icon size={16} />
    </span>
    <div>
      <span>{title}</span>
      {content && <p className="text-muted-foreground">{content}</p>}
    </div>
  </li>
)

export default ExperienceHighlight
